import { TextField, useColorScheme } from "@mui/material";
import { useRef } from 'react';

interface NameInputProps {
  name: string;
  setName: React.Dispatch<React.SetStateAction<string>>;
}

export default function NameInput({ name, setName }: NameInputProps) {
  const { mode, systemMode } = useColorScheme();

  return (
    <TextField
      sx={{
        height: '50%',
        ...((mode === 'dark' || systemMode === 'dark') ? {
          '& .MuiOutlinedInput-input:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 100px #050f02ff inset !important',
          },
        } : {
          '& .MuiOutlinedInput-input:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 100px #ffffff inset !important',
          },
        })
      }}
      autoComplete="name"
      name="name"
      fullWidth
      id="name"
      label="Nome completo"
      placeholder="João Santos da Silva"
      value={name}
      onChange={(e) => setName(e.target.value)}
    />
  )
}